module.exports = __webpack_public_path__ + "static/media/website.5f98e7fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/website.jpg
// module id = 253
// module chunks = 0